import * as React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

import { Context } from '../../context/DataContext';

const PaymentValidationPage = () => {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const [searchParams] = useSearchParams();
  const { setCustomerInfo, setTokenLogin, validation3DPayment } = React.useContext(Context);

  const status = searchParams.get('status');

  React.useEffect(() => {
    const URL_POSTFIX = `loginType=${searchParams.get('loginType') || 'member'}${searchParams.get('token') ? `&token=${searchParams.get('token')}` : ''}`;

    if (status !== '0') {
      navigate(`/extend-new/payment/${orderId}/fail?${URL_POSTFIX}`, { replace: true });
    } else {
      validation3DPayment(
        {
          orderId,
          status,
          rec_trade_id: searchParams.get('rec_trade_id') || '',
          order_number: searchParams.get('order_number') || '',
          bank_transaction_id: searchParams.get('bank_transaction_id') || '',
          auth_code: searchParams.get('auth_code') || '',
        },
        ({ responseCode, responseMsg }) => {
          if (responseCode === '000') {
            setTokenLogin({ tokenLogin: searchParams.get('loginType') === 'token', token: searchParams.get('token') || '' }, () => {
              setCustomerInfo({ orderId }, () => {
                navigate('/extend-new/upload-photos');
              });
            });
          } else {
            navigate(
              `/extend-new/payment/${orderId}/fail?errMsg=${responseMsg}&${URL_POSTFIX}`,
              { replace: true }
            );
          }
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Backdrop
      open
      sx={(theme) => ({
        flexDirection: 'column',
        zIndex: theme.zIndex.drawer + 1,
      })}>
      <CircularProgress
        sx={{ mb: 6 }}
        size={120}
      />
      <Typography
        variant='h5'
        color='whitesmoke'>
        資料處理中，請稍候...
      </Typography>
    </Backdrop>
  );
};

export default PaymentValidationPage;
